import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

// import Home from '../views/Home.vue'
import DevSignup from '../views/DevSignup.vue';
import Fullname from '../components/devsignup/Fullname.vue';
import Speciality from '../components/devsignup/Speciality.vue';
import FullstackDev from '../components/devsignup/FullstackDev.vue';
import Overview from '../components/devsignup/Overview.vue';
import OtherDevs from '../components/devsignup/OtherDevs.vue';
import Experience from '../components/devsignup/Experience.vue';
import HourlyRates from '../components/devsignup/HourlyRates.vue';
import Register from '../views/Register.vue';

import DevProfile from '../views/DevProfile.vue';
import JobDetails from '../views/JobDetails.vue';
import Projects from '../views/Projects.vue';
import JobProfile from '../views/JobProfile.vue';
import Proposals from '../views/Proposals.vue';
import DevSkillScore from '../views/DevSkillScore.vue';
import JobGotten from '../views/JobGotten.vue';
import Browse from '../views/Browse.vue';
import Chat from '../views/Chat.vue';
import Hired from '../views/Hired.vue';
import OfficeJobs from '../views/OfficeJobs.vue';
import Settings from '../views/Settings.vue';
import Payments from '../views/Payments.vue';
import DevDetails from '../views/DevDetails.vue';
import Login from '../views/Login.vue';
import Tests from '../views/Tests.vue';

Vue.use(VueRouter);

const pageProgress = {
  func: [
    { call: 'color', modifier: 'temp', argument: '#ffb000' },
    { call: 'fail', modifier: 'temp', argument: '#6e0000' },
    { call: 'location', modifier: 'temp', argument: 'top' },
    {
      call: 'transition',
      modifier: 'temp',
      argument: { speed: '1.5s', opacity: '0.6s', termination: 400 },
    },
  ],
};

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/login',
  },
  {
    path: '/devsignup',
    name: 'devsignup',
    component: DevSignup,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
    children: [
      { path: '', component: Fullname },
      { path: 'speciality', component: Speciality },
      { path: 'fullstack', component: FullstackDev },
      { path: 'devs', component: OtherDevs },
      { path: 'experience', component: Experience },
      { path: 'complete', component: HourlyRates },
      { path: 'overview', component: Overview },
    ],
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: DevProfile,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/job-details',
    name: 'job-details',
    component: JobDetails,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: Projects,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/job-profile',
    name: 'job-profile',
    component: JobProfile,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/proposals',
    name: 'proposals',
    component: Proposals,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/skill-score',
    name: 'skill-score',
    component: DevSkillScore,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/job-gotten',
    name: 'job-gotten',
    component: JobGotten,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/browse',
    name: 'browse',
    component: Browse,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/chat',
    name: 'chat',
    component: Chat,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/hired',
    name: 'hired',
    component: Hired,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/office-jobs',
    name: 'office-jobs',
    component: OfficeJobs,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/tests',
    name: 'tests',
    component: Tests,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/payments',
    name: 'payments',
    component: Payments,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/dev-details',
    name: 'dev-details',
    component: DevDetails,
    meta: {
      requiresAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      hideForAuth: true,
      progress: pageProgress,
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const talentData = JSON.parse(localStorage.getItem('talentData'));
  if (talentData) store.commit('talent/addToTalent', talentData);

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // console.log(store.getters.isLoggedIn);
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next('/login');
    // next()
  } else {
    next();
  }

  if (to.matched.some((record) => record.meta.hideForAuth)) {
    if (store.getters.isLoggedIn) {
      next({ path: '/profile' });
    }
  } else {
    next();
  }
});

export default router;
